var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInProgress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 4C19.0466 4 22.1886 5.20282 24.4929 7.50711C29.2024 12.2166 29.2024 19.7834 24.4929 24.4929C19.7834 29.2024 12.2166 29.2024 7.50712 24.4929C3.63135 20.6171 2.98421 14.8045 5.47585 10.2826L3.72418 9.3174C0.815825 14.5955 1.56869 21.3829 6.09291 25.9071C11.5834 31.3976 20.4166 31.3976 25.9071 25.9071C31.3976 20.4166 31.3976 11.5834 25.9071 6.09289C23.2114 3.39718 19.5534 2 16 2V4ZM7.50388 6.1005C7.8944 6.49102 7.8944 7.12418 7.50388 7.5147C7.11336 7.90522 6.4802 7.90522 6.08968 7.5147C5.69916 7.12418 5.69916 6.49102 6.08968 6.1005C6.4802 5.70998 7.11336 5.70998 7.50388 6.1005Z",
    fill: "current",
    className: "filled",
    strokeWidth: 0
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgress);
export default __webpack_public_path__ + "static/media/InProgress.62a78fd0.svg";
export { ForwardRef as ReactComponent };